import api from './axiosInstance'

export default {
    contactUs(name, email, subject, message, captcha) {
        const data = { name, email, subject, message, captcha };
        return api.post('contactUs', data);
    }
}
